import React from 'react'
import { Check as CheckIcon } from 'react-feather'
import PropTypes from 'prop-types'
import { Box, Button, Dialog, Typography } from '@material-ui/core'

import theme from 'theme'

const NoFilterDataDialog = ({ open, setOpen }) => {
  const onClose = (e, reason) => {
    if (reason === 'backdropClick') return
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        m={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gridGap={theme.spacing(2)}
        textAlign="center"
      >
        <Typography variant="h3">
          Não foram encontrados processos com as condições selecionadas. Ajuste
          os filtros e tente novamente.
        </Typography>
      </Box>
      <Box mx={3} mb={2} display="flex" justifyContent="center">
        <Button
          disableElevation
          variant="contained"
          color="primary"
          onClick={() => setOpen(false)}
          startIcon={<CheckIcon />}
        >
          Entendido
        </Button>
      </Box>
    </Dialog>
  )
}

NoFilterDataDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default NoFilterDataDialog
